import type { Action, Store, UnknownAction } from '@reduxjs/toolkit'
import { getSessionState, type SessionState } from '#features/User/userManager'

export const storeSessionChangeType = '__system/session-change'
export type SessionChange =
  | {
      expired: true
    }
  | {
      expired: false
      expiry: number
    }

export const storeSessionChangeMatcher = (action: UnknownAction): action is Action<typeof storeSessionChangeType> & { payload: SessionChange } =>
  action.type === storeSessionChangeType

const makeSessionStateListener = (store: Store) => (sessionState: SessionState) => {
  const user = sessionState.user
  if (!user) {
    store.dispatch({
      type: '__system/session-change',
      payload: {
        expired: true,
      } satisfies SessionChange,
    })
  } else {
    store.dispatch({
      type: storeSessionChangeType,
      payload: {
        expired: false,
        expiry: user.expires_in ?? 0,
      } satisfies SessionChange,
    })
  }
}

export const addUserSessionNotifier = (store: Store) => {
  const listener = makeSessionStateListener(store)
  const currentSessionState = getSessionState()
  if (currentSessionState.user) {
    listener(currentSessionState)
  }
  currentSessionState.sessionStateListeners.add(listener)
}
